import '../DataCollectionGroupPanel.css'

import { Table, td, tr } from 'react-bootstrap'

import React from 'react'
import { convertToFixed } from '../../../../helpers/NumericTransformationsHelper.js'

export default class FourSectionPanel extends React.Component {
  getRow(key, value) {
    return (
      <tr>
        <td xs={5} md={5} className="parameterKey">
          {key}
        </td>
        <td xs={7} md={7} className="parameterValue">
          {value}
        </td>
      </tr>
    )
  }

  /** If not null it returns the first element of the array **/
  getFirstElement(array) {
    if (array) {
      try {
        return array.split(',')[0]
      } catch (e) {
        return 'Error'
      }
    }
  }

  render() {
    return (
      <Table>
        <tbody>
          {this.getRow('Synchrotron name', this.props.datacollectiongroup.synchrotronName)}
          {this.getRow('Synchrotron filling mode', this.props.datacollectiongroup.fillingMode)}
          {this.getRow(
            'Synchrotron Current',
            convertToFixed(this.getFirstElement(this.props.datacollectiongroup.current), 1)
          )}
          {this.getRow('Undulator types', this.props.datacollectiongroup.undulatorsTypes)}
          {this.getRow('Undulator gaps', this.props.datacollectiongroup.undulatorsGaps)}
        </tbody>
      </Table>
    )
  }
}
